import Vue from 'vue'
import Router from 'vue-router';

import Parse from '@/services/parse.js'

import TV from '@/components/TV.vue'
import Login from '@/components/Login.vue'
import Dashboard from '@/components/Dashboard.vue'
import DashboardPreview from '@/components/DashboardPreview.vue'
import Fanfest from '@/components/FanFest.vue'
import ClientError from '@/components/Error.vue'

import FanFestLogin from '@/components/FanFestLogin.vue'

Vue.use(Router)

const routes = [
  {
    path: '/client-error',
    name: 'client-error',
    component: ClientError
  },
  {
    path: '/dashboard/preview/:vod',
    name: 'dashboardpreview',
    component: DashboardPreview,
    beforeEnter: (to, from, next) => {
      if (!Parse.User.current()) {
        next({ name: 'login' })
      }
      else next()
    }
  },
  {
    path: '/dashboard/fanfest',
    name: 'fanfest',
    component: Fanfest,
    beforeEnter: (to, from, next) => {
      if (!Parse.User.current()) {
        next({ name: 'login' })
      }
      else next()
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      if (!Parse.User.current()) {
        next({ name: 'login' })
      }
      else next()
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (Parse.User.current()) {
        next({ name: 'dashboard' })
      }
      else next()
    }
  },
  {
    path: '/user/:username/live',
    name: 'live',
    component: Fanfest,
  },
  {
    path: '/fanfest/login',
    name: 'fanfest-login',
    component: FanFestLogin,
  },
  {
    path: '/:organizer',
    name: 'tv',
    component: TV,
  },
  {
    path: '*',
    redirect: { name: 'fanfest-login' }
  }
];

const router = new Router({
  mode: 'history',
  routes
});

export default router;